import { STYLOVYZE_FLAGS, } from '@innovyze/stylovyze/lib/types/features';
import { useSelectFeatures } from '@innovyze/stylovyze/lib/selectors';
// Keep the features returned properly typed
export function useIsFeatureEnabled(feature) {
    const features = useSelectFeatures();
    return features[feature];
}
export function useIsDebugModeEnabled() {
    return !!useIsFeatureEnabled(STYLOVYZE_FLAGS.DEBUG_MODE);
}
// legacy exports (incorrect hook shape)
export function isFeatureEnabled(feature) {
    console.warn('Warning - the function isFeatureEnabled() is deprecated. Switch to use useIsFeatureEnabled instead');
    // eslint-disable-next-line
    return useIsFeatureEnabled(feature);
}
